import { render } from "./Billing_table.vue?vue&type=template&id=1b23b008&scoped=true"
import script from "./Billing_table.vue?vue&type=script&lang=js"
export * from "./Billing_table.vue?vue&type=script&lang=js"

import "./Billing_table.vue?vue&type=style&index=0&id=1b23b008&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b23b008"]])

export default __exports__